/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Not_Specified12Inputs */

const en__field_enum_not_specified12 = /** @type {(inputs: _Field_Enum_Not_Specified12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not specified`)
};

const de__field_enum_not_specified12 = /** @type {(inputs: _Field_Enum_Not_Specified12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Angabe`)
};

/**
* | output |
* | --- |
* | "Not specified" |
*
* @param {_Field_Enum_Not_Specified12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_not_specified12 = /** @type {((inputs?: _Field_Enum_Not_Specified12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Not_Specified12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_not_specified12(inputs)
	return de__field_enum_not_specified12(inputs)
});
export { _field_enum_not_specified12 as "_field_enum_NOT_SPECIFIED" }